<!-- 应用列表 -->
<template>
   <t-dialog 
    class="wx-dialog-title-box"
      width="1008px"
      v-model:visible="visible"
      :placement="'center'"
      :footer="false"
      :on-cancel="onCancel"
      :on-close="onCancel"
    >
    <template #header>
          应用列表
    </template>
    <template #body>
        <div  class="applist" style="overflow-y: auto;height: 600px;">
            <div
                v-for="(element,index) in stateList"
                :key="index+'666'"
            >
            <!-- <draggable
                :list="stateList"
                animation="300"
                :disabled="false"
            >
                <template #item="{ element }"> -->
                <div class="item">
                    <div class="typeApp">
                    <div class="typeHead">
                        <h3>{{ element.name }}</h3>
                    </div>

                    <div class="listapp">
                        <ul>
                        <li v-for="item in element.applicationRes" :key="item.id+'12'" @click.stop="OpenUrl(item)">
                            <div class="appicon">
                                <img  class="icobtnIcon" v-if="item.id=='1'"   src="@/assets/platformIcon/sgkt.png" alt="" size="24">
                                <img  class="icobtnIcon" v-else-if="item.id=='7'"   src="@/assets/platformIcon/jk.png" alt="" size="24">
                                <img  class="icobtnIcon" v-else-if="item.id=='8'"   src="@/assets/platformIcon/dd.png" alt="" size="24">
                                <img  class="icobtnIcon" v-else-if="item.id=='222222'"   src="@/assets/platformIcon/jk.png" alt="" size="24">
                                <img  class="icobtnIcon" v-else-if="item.id=='333333'"   src="@/assets/platformIcon/dd.png" alt="" size="24">
                                <img  class="icobtnIcon" v-else-if="item.id=='6'"   src="@/assets/platformIcon/zhkt.png" alt="" size="24">
                                <img  class="icobtnIcon" v-else-if="item.id=='5'"   src="@/assets/platformIcon/wx.png" alt="" size="24">
                                <img  class="icobtnIcon" v-else-if="item.id=='101'"   src="@/assets/platformIcon/ztgl.png" alt="" size="24">
                                <img  class="icobtnIcon" v-else-if="item.id=='102'"   src="@/assets/platformIcon/ztgl.png" alt="" size="24">
                                <img  class="icobtnIcon" v-else-if="item.id=='200'"   src="@/assets/platformIcon/ztgl.png" alt="" size="24">
                                <img  class="icobtnIcon" v-else-if="item.id=='202'"   src="@/assets/platformIcon/sgkt.png" alt="" size="24">
                                <img  class="icobtnIcon" v-else-if="item.icon!==''"   :src="item.icon" alt="" size="24">
                                <img  class="icobtnIcon" v-else="item.icon==''"   src="@/assets/platformIcon/wx.png" alt="" size="24">
                            </div>
                            <div class="appname">
                                <p>{{ item.name }}</p>
                                <t-tag theme="primary" variant="light">
                                        <img  class="webicon"   src="@/assets/platformIcon/diannao.png" alt="" >
                                        &nbsp;&nbsp;Web
                                </t-tag>
                            </div>
            
                            <t-icon  class="icobtn chevron-right"  style="opacity: 0;" name="chevron-right" size="20" />
                        </li>
                        </ul>
                        <div style="height: 50px;"></div>
                    </div>
                    
                    </div>
                </div>
                <!-- </template> -->
            <!-- </draggable> -->
            </div>
        </div>
    </template>
      
    </t-dialog>
  </template>
  
  <script setup>
  import { onMounted, onBeforeUnmount, ref } from "vue";
  // import draggable from "vuedraggable";// 基于 sortablejs
  import { getApplictations } from "@/api/AppList";

  

  const stateList = ref([]); 
  const visible = ref(false); 
  const pageDate = ref({
  pageNum: 1,
  pageSize: 100,
  queryName: "", // 输入框搜索
});
  
  function Initialize() {
  getApplictations(pageDate.value).then((res) => {
    if (res.code == 1) {
      // appData.value = res.data;
      stateList.value = res.data;
    }
  })
}
  const onCancel = ()=>{
    visible.value = false;
  }
  
  function Openadd() {
    Initialize()
    visible.value = true;

}

  
  //打开应用
function OpenUrl(row){
    // console.log(row);
    let href  = ''
    if(row.parentId == '31415926525'){ //系统应用
        href = window.location.protocol + '//' + window.location.host + row.webPath
    }else{// 自定义应用
        href =  row.webPath 
    }

    // if(row.webPath == ''){
    //     //  无地址禁止跳转
    //     return
    // }

    window.open(href)
}

  
  onMounted(()=>{
    // Initialize();
  })

  //ref调用暴露方法
defineExpose({
  Openadd,
});

  </script>
  <style lang="less" scoped>
    .applist{
        flex: 1;
        padding: 30px 32px;
        display: flex;
        box-sizing: border-box;
        flex-direction: column;
        row-gap: 10px;
        overflow: hidden;
        overflow-y: auto;
        .typeApp{
            display: flex;
            flex-direction: column;
            row-gap: 10px;
            padding: 10px 0px;
            .typeHead{
                height: 52px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                align-self: stretch;
                h3{
                    color: var(--text-icon-font-gy-260-secondary);
                    font-family: "PingFang SC";
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 600;
                }
                .iconw{
                    width: 18px;
                    height: 18px;
                }
            }
            .listapp{
                 min-height: 80px;
                ul{
                    display: flex;
                    flex-wrap: wrap;
                    row-gap: 24px;
                    gap: 24px;
                    li{
                        flex-basis: 177px;
                        height: 63px;
                        padding: 16px;
                        border-radius: 4px;
                        background: var(--Gray-White);
                        box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.08), 0px 4px 5px 0px rgba(0, 0, 0, 0.04), 0px 1px 10px 0px rgba(0, 0, 0, 0.02);
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: center;
                        cursor: pointer;
                        .appicon{
                            width: 40px;
                            height: 40px;
                            border-radius: 20px;
                            background: #f2f3ff;
                            text-align: center;
                            position:relative;
                            .icobtnIcon{
                                width: 30px;
                                height: 30px;
                                border-radius: 50%;
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                            }
                        }
                        .appname{
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            row-gap: 5px;
                            p{
                                width: 115px;
                                text-align: center;
                                color: var(--text-icon-font-gy-190-primary);
                                font-family: "PingFang SC";
                                font-size: 14px;
                                font-style: normal;
                                font-weight: 400;
                                line-height: 22px; /* 157.143% */
                            }
                        }
                        /deep/ .t-tag{
                            height: 20px;
                        }
                    }
                }
                .webicon{
                    width: 15px;
                    height: 15px;
                    vertical-align: -3px;
                }
            }
        }
    }
  </style>
  